export const graphqlBaseUrl = "https://older-limiting-supporting-guide.trycloudflare.com/graphql/creators";
// export const graphqlBaseUrl = process.env.REACT_APP_BACKEND_URL;
